import { render, staticRenderFns } from "./MaxRewardPerStore.vue?vue&type=template&id=5fb20f46&scoped=true&"
import script from "./MaxRewardPerStore.vue?vue&type=script&lang=js&"
export * from "./MaxRewardPerStore.vue?vue&type=script&lang=js&"
import style0 from "./MaxRewardPerStore.vue?vue&type=style&index=0&id=5fb20f46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb20f46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fb20f46')) {
      api.createRecord('5fb20f46', component.options)
    } else {
      api.reload('5fb20f46', component.options)
    }
    module.hot.accept("./MaxRewardPerStore.vue?vue&type=template&id=5fb20f46&scoped=true&", function () {
      api.rerender('5fb20f46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wsgtdrive/components/MaxRewardPerStore.vue"
export default component.exports